module.exports = __webpack_public_path__ + "img/大图2.9a4b68fd.jpg";